/* global ajax_object */

// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/menu.js'; // eslint-disable-line
import './sections/about-scroll';
import './sections/faq-videos';

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

if (document.querySelector('[data-fancybox]')) {
  import('./plugins/fancybox');
}

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

const setHeaderHeight = () => {
  const header = document.querySelector('.header');

  if (header) {
    document.body.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  }
};

function initBlogSlider() {
  const $slider = $('.blog-posts__slider');

  if (window.innerWidth <= 1081) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 782,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

/**
 * Scripts which runs after DOM load
 */
$(function () {
  /**
   * Posts and  Videos Filtration
   */

  const postPerPage = 12;
  let isLoading = false;

  let selectedCats = []; // applied
  let pendingCats = []; // currently checked in dropdown
  function selectedCatsCSV() {
    return selectedCats.map((c) => c.id).join(',');
  }

  // function normalizeCatsFromDOM($items) {
  //   const cats = [];
  //   $items.each(function () {
  //     const id = $(this).data('category');
  //     const name =
  //       $(this).data('name') || $(this).find('.cat-label').text().trim();
  //     if (id) cats.push({ id, name });
  //   });
  //   return cats;
  // }

  function syncDropdownUI() {
    const selectedIds = new Set(pendingCats.map((c) => String(c.id)));

    $('.post-list__category_wrapper .cat-name').each(function () {
      const id = String($(this).data('category') || '');
      const isAll = id === '';

      const isChecked = isAll ? selectedIds.size === 0 : selectedIds.has(id);

      $(this).toggleClass('active', isChecked);
      $(this).find('.cat-check').prop('checked', isChecked);
      $(this).attr('aria-selected', isChecked ? 'true' : 'false');
    });
  }

  function renderSelectedCats() {
    const $wrap = $('.category-tags');
    $wrap.find('.cat-pill').remove();

    selectedCats.forEach((c) => {
      const pill = `
<button type="button" class="cat-pill" data-category="${c.id}">
<span class="cat-pill__label">${c.name}</span>
</button>`;
      $wrap.find('.clear-filters').before(pill);
    });

    $wrap.find('.clear-filters').toggle(selectedCats.length > 0);
  }

  function openDropdown() {
    $('.show-cat-btn').addClass('is-active').attr('aria-expanded', 'true');
    $('.post-list__category').addClass('show').attr('aria-hidden', 'false');

    // Copy applied -> pending when opening
    pendingCats = selectedCats.map((c) => ({ ...c }));
    syncDropdownUI();
  }

  function closeDropdown() {
    $('.show-cat-btn').removeClass('is-active').attr('aria-expanded', 'false');
    $('.post-list__category').removeClass('show').attr('aria-hidden', 'true');
  }

  function loadScrollPosts(_response, reset = false) {
    if (isLoading) return false;
    isLoading = true;

    const $wrap = $('.ajax-loading');
    const $btn = $wrap.find('.post-load');

    const offset = reset ? 0 : $('.ajax-item').length;

    const postType =
      $('.post-load').data('post-type') ||
      $('.ajax-loading').data('post-type') ||
      'post';

    $.ajax({
      type: 'GET',
      dataType: 'json',
      url: ajax_object.ajax_url,
      data: {
        action: 'loadmore',
        postType: postType,
        offset: offset,
        postperpage: postPerPage,
        categories: selectedCatsCSV(),
      },
      beforeSend: function () {
        $wrap.show();
        $btn.addClass('is-loading').prop('disabled', true);
      },
      success: function (response) {
        if (!response || !response.success) {
          console.warn('AJAX failed', response);
          return;
        }

        if (reset) $('.ajax-posts').html(response.data.html);
        else $('.ajax-posts').append(response.data.html);

        const loaded = $('.ajax-item').length;
        const total = parseInt(response.data.post_count, 10) || 0;

        if (loaded < total) $wrap.show();
        else $wrap.hide();
      },
      complete: function () {
        isLoading = false;
        $btn.removeClass('is-loading').prop('disabled', false);
      },
    });

    return false;
  }

  $('#load-more-testimonials').on('click', function () {
    let button = $(this);
    let page = button.data('page'); // current page

    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: {
        action: 'load_more_testimonials',
        page: page,
      },
      beforeSend: function () {
        button.text('Loading...');
      },
      success: function (response) {
        if (response.includes('<!-- no-more-posts -->')) {
          $('#testimonials-wrapper').append(
            response.replace('<!-- no-more-posts -->', '')
          ); // append last page
          button.fadeOut(); // hide button
        } else {
          $('#testimonials-wrapper').append(response);
          button.data('page', page + 1); // increment page
          button.text('Load More');
        }
      },
    });
  });

  // Toggle dropdown
  $(document).on('click', '.show-cat-btn', function (e) {
    e.preventDefault();
    const isOpen = $('.post-list__category').hasClass('show');
    if (isOpen) closeDropdown();
    else openDropdown();
  });

  // Click on list item toggles checkbox
  $(document).on(
    'click',
    '.post-list__category_wrapper .cat-name',
    function (e) {
      e.preventDefault();

      const id = String($(this).data('category') || '');
      const name =
        $(this).data('name') || $(this).find('.cat-label').text().trim();

      // All
      if (!id) {
        pendingCats = [];
        syncDropdownUI();
        return;
      }

      const idx = pendingCats.findIndex((c) => String(c.id) === id);
      if (idx === -1) pendingCats.push({ id, name });
      else pendingCats.splice(idx, 1);

      syncDropdownUI();
    }
  );

  // Apply
  $(document).on('click', '.apply-filters', function (e) {
    e.preventDefault();

    selectedCats = pendingCats.map((c) => ({ ...c }));
    renderSelectedCats();
    closeDropdown();
    loadScrollPosts(null, true);
  });

  // Remove pill
  $(document).on('click', '.cat-pill', function (e) {
    e.preventDefault();
    const id = String($(this).data('category'));

    selectedCats = selectedCats.filter((c) => String(c.id) !== id);
    pendingCats = selectedCats.map((c) => ({ ...c }));

    renderSelectedCats();
    syncDropdownUI();
    loadScrollPosts(null, true);
  });

  // Clear
  $(document).on('click', '.clear-filters', function (e) {
    e.preventDefault();

    selectedCats = [];
    pendingCats = [];

    renderSelectedCats();
    syncDropdownUI();
    closeDropdown();
    loadScrollPosts(null, true);
  });

  // Load more
  $(document).on('click', '.post-load', function (e) {
    e.preventDefault();
    loadScrollPosts(null, false);
  });

  // Close dropdown when clicking outside
  $(document).on('click', function (e) {
    const $target = $(e.target);
    if ($target.closest('.category-wrapper').length) return;
    closeDropdown();
  });

  renderSelectedCats();
  syncDropdownUI();

  initBlogSlider();
  $(window).on('resize', function () {
    initBlogSlider();
  });
  //Sidebar toggle
  const toggleButton = document.querySelector('.js-legal-services-toggle');

  if (toggleButton) {
    const menuWrapper = toggleButton.nextElementSibling;

    if (menuWrapper && menuWrapper.tagName === 'DIV') {
      menuWrapper.classList.add('js-legal-services-menu');

      toggleButton.addEventListener('click', function () {
        if (window.innerWidth > 782) return;

        menuWrapper.classList.toggle('is-open');
        toggleButton.classList.toggle('active');
      });
    }
  }

  //Stacked sections scroll detection
  const sections = document.querySelectorAll('.stacked-section');

  if (sections.length && window.innerWidth >= 768) {
    let ticking = false;

    const update = () => {
      const scrolled = window.scrollY > 0;

      sections.forEach((section) => {
        section.classList.toggle('is-scrolling', scrolled);
      });

      ticking = false;
      if (typeof $.fn.matchHeight === 'function') {
        $.fn.matchHeight._update();
      }
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    update();
  }
  // Stacked sections intersection observer
  (() => {
    const sections = document.querySelectorAll('.stacked-section');
    if (sections.length && window.innerWidth >= 768) {
      const io = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-active');
            } else {
              entry.target.classList.remove('is-active');
            }
          }
        },
        {
          threshold: 0.5,
        }
      );
      sections.forEach((sec) => io.observe(sec));
    }
  })();

  // Home Hero color changing
  if ($('.color-shift-section').length && window.innerWidth >= 768) {
    Promise.all([import('gsap'), import('gsap/ScrollTrigger')]).then(
      ([{ gsap }, { ScrollTrigger }]) => {
        gsap.registerPlugin(ScrollTrigger);

        gsap.to('.color-shift-section', {
          backgroundColor: '#ffffff',
          scrollTrigger: {
            trigger: '.color-shift-section',
            start: 'top top-=300',
            end: 'top top-=500',
            scrub: 0.6,
          },
        });

        gsap.to('.color-shift-section .hero-img', {
          opacity: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: '.color-shift-section',
            start: 'top top-=300',
            end: 'top top-=450',
            scrub: 0.3,
          },
        });
      }
    );
  }

  // Marquee initializer: clones items so content repeats seamlessly, measures width and sets CSS vars
  (function initMarquee() {
    document.querySelectorAll('.marquee__inner').forEach((track) => {
      if (track.dataset.initialized) return;
      const originals = Array.from(track.children);
      if (!originals.length) return;

      const compute = (els) => {
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return (
          els.reduce((s, el) => s + el.getBoundingClientRect().width, 0) +
          gap * (els.length - 1)
        );
      };

      requestAnimationFrame(() => {
        const container = track.parentElement || track;
        const originalWidth = compute(originals);
        const target = (container.clientWidth || window.innerWidth) * 2;

        // append full batches of originals until track is wide enough (safety cap)
        let batches = 0;
        while (compute(Array.from(track.children)) < target && batches < 6) {
          originals.forEach((el) => track.appendChild(el.cloneNode(true)));
          batches++;
        }

        track.style.setProperty('--marquee-distance', originalWidth + 'px');
        const duration = Math.max(10, Math.round((originalWidth / 1200) * 30));
        track.style.setProperty('--marquee-duration', duration + 's');

        track.dataset.initialized = '1';
        container.addEventListener('mouseenter', () =>
          track.classList.add('is-paused')
        );
        container.addEventListener('mouseleave', () =>
          track.classList.remove('is-paused')
        );

        // debounced resize: remove appended clones and re-init
        let t;
        window.addEventListener('resize', () => {
          clearTimeout(t);
          t = setTimeout(() => {
            const keep = originals.length;
            while (track.children.length > keep)
              track.removeChild(track.lastChild);
            delete track.dataset.initialized;
            initMarquee();
          }, 150);
        });
      });
    });
  })();

  //Show More Cases
  const items = document.querySelectorAll('.case-item');
  const button = document.querySelector('.case-results__more');

  if (!items.length || !button) return;

  const perLoad = 4;
  let visible = perLoad;

  items.forEach((item, index) => {
    if (index >= perLoad) {
      item.classList.add('is-hidden');
    } else {
      item.classList.add('is-visible');
    }
  });

  button.addEventListener('click', function () {
    const next = visible + perLoad;

    items.forEach((item, index) => {
      if (index < next) {
        item.classList.remove('is-hidden');
        item.classList.add('is-visible');
      }
    });

    visible = next;

    if (visible >= items.length) {
      button.style.display = 'none';
    }
  });
  /**
   * Accordion
   */
  const $accordionTitles = $('.accordion__title');

  $accordionTitles.each(function () {
    // Initialize aria-expanded based on active class
    const $this = $(this);
    const $accordionItem = $this.closest('.accordion__item');
    const expanded = $accordionItem.hasClass('active') ? 'true' : 'false';
    $this.attr('aria-expanded', expanded);
  });

  $accordionTitles.on('click', function () {
    const $this = $(this);
    const $accordionItem = $this.closest('.accordion__item');
    const $accordionContent = $accordionItem.find('.accordion__content');

    if ($accordionItem.hasClass('active')) {
      $accordionContent.slideUp(300, function () {
        $accordionItem.removeClass('active');
        $this.attr('aria-expanded', 'false');
      });
    } else {
      // Close other open accordion items
      $this
        .closest('.accordion')
        .find('.accordion__item.active .accordion__content')
        .slideUp(300, function () {
          const $parentItem = $(this).closest('.accordion__item');
          $parentItem.removeClass('active');
          $parentItem.find('.accordion__title').attr('aria-expanded', 'false');
        });

      // Open the clicked accordion item
      $accordionContent.slideDown(300, function () {
        $accordionItem.addClass('active');
        $this.attr('aria-expanded', 'true');
      });
    }
  });

  // Allow Enter and Space to toggle the accordion when the title (button) is focused

  $(document).on('keydown', '.accordion__title', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   threshold: 0.5,
  //   once: true,
  //   onShown: function (element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function (i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function () {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  /**
   * Create CSS variable for header height
   */
  setHeaderHeight();
});
$(document).ready(function () {
  if (!document.querySelector('.areas-list-section .areas-list')) return;

  let currentLetter = '';
  let currentSearch = '';
  let currentPage = 1;
  let maxPages = 1;
  let typingTimer;

  function loadAreas(reset = true) {
    if (reset) currentPage = 1;

    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: {
        action: 'filter_areas',
        letter: currentLetter,
        search: currentSearch,
        paged: currentPage,
      },
      beforeSend: function () {
        // optional loader
        $('.areas-list').addClass('loading');
      },
      success: function (response) {
        if (reset) {
          $('.areas-list').html(response.html);
          $('.matchHeight').matchHeight();
        } else {
          $('.areas-list').append(response.html);
          $('.matchHeight').matchHeight();
        }

        maxPages = response.max_pages;

        // show / hide load more button
        if (currentPage >= maxPages) {
          $('.areas-list-section .button-wrapper').hide();
        } else {
          $('.areas-list-section .button-wrapper').show();
        }
      },
      error: function (xhr, status, error) {
        console.log('AJAX Error:', error);
      },
      complete: function () {
        $('.areas-list').removeClass('loading');
      },
    });
  }

  // 🔤 Letter filter
  $('.alphabet-block span').on('click', function () {
    $('.alphabet-block span').removeClass('active');
    $(this).addClass('active');

    currentLetter = $(this).data('letter') || '';
    loadAreas(true);
  });

  // 🔎 Search with debounce
  $('#areas-search').on('keyup', function () {
    clearTimeout(typingTimer);

    currentSearch = $(this).val();

    typingTimer = setTimeout(function () {
      loadAreas(true);
    }, 400);
  });

  // ❌ Clear filters
  $('.clear-block button').on('click', function () {
    currentLetter = '';
    currentSearch = '';
    currentPage = 1;

    $('#areas-search').val('');
    $('.alphabet-block span').removeClass('active');

    loadAreas(true);
  });

  // ➕ Load more
  $('.areas-list-section .button').on('click', function () {
    if (currentPage < maxPages) {
      currentPage++;
      loadAreas(false);
    }
  });

  // 🚀 Initial load (optional but recommended)
  loadAreas(true);
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  resizeVideo();

  /**
   * Create CSS variable for header height
   */
  setHeaderHeight();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});

// Hide header on scroll down, show on scroll up
(function () {
  const $header = $('.header');
  const $stickyPhone = $('.sticky-phone-desktop'); // новий елемент
  if (!$header.length) return;

  let lastScroll = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;
  const delta = 10; // minimum px change to consider
  const showAfter = 60; // don't hide header if near top

  function onScroll() {
    const current = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(current - lastScroll) <= delta) {
      ticking = false;
      return;
    }

    // If mobile menu is open, keep header visible
    const menuIsOpen =
      $('.top-bar').hasClass('is-active') ||
      $('.menu-icon').hasClass('is-active');
    if (menuIsOpen) {
      if ($header.hasClass('is-hidden')) $header.removeClass('is-hidden');
      lastScroll = current <= 0 ? 0 : current;
      ticking = false;
      return;
    }

    if (current > lastScroll && current > showAfter) {
      // scrolled down
      if (!$header.hasClass('is-hidden')) {
        $header.addClass('is-hidden');
        document.body.classList.add('header--hidden');
      }

      if ($stickyPhone.length && !$stickyPhone.hasClass('is-visible')) {
        $stickyPhone.addClass('is-visible');
      }
    } else if (
      current + window.innerHeight < document.body.scrollHeight ||
      current <= showAfter
    ) {
      // scrolled up or near top
      if ($header.hasClass('is-hidden')) {
        $header.removeClass('is-hidden');
        document.body.classList.remove('header--hidden');
      }

      // $stickyPhone.removeClass('is-visible');
    }

    lastScroll = current <= 0 ? 0 : current; // for Mobile or negative scrolling
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );
})();

document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.submenu-toggle');

  function updateParentsHeight(el) {
    let parentSubmenu = el.closest('.menu.submenu');

    while (parentSubmenu) {
      parentSubmenu.style.maxHeight = parentSubmenu.scrollHeight + 'px';
      parentSubmenu = parentSubmenu.parentElement.closest('.menu.submenu');
    }
  }

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();

      const parent = this.closest('.has-dropdown');
      const submenu = parent.querySelector(':scope > .menu.submenu');
      const expanded = this.getAttribute('aria-expanded') === 'true';

      this.setAttribute('aria-expanded', !expanded);
      parent.classList.toggle('submenu-open');

      if (submenu) {
        if (expanded) {
          submenu.style.maxHeight = null;
        } else {
          submenu.style.maxHeight = submenu.scrollHeight + 'px';
          updateParentsHeight(submenu);
        }
      }
    });
  });
});
